export default __webpack_public_path__ + "static/media/Group39682.52cc31a5.png";